export default "__VITE_ASSET__nVOUI2oo__"